import cx from 'classnames'
import { LinkModal } from 'common/LinkModal/LinkModal'
import { getHistoryInstance } from 'hooks/useHistory'
import { PRIORITY_EDITOR } from 'proseShared/constants'
import queryClient from 'queryClient'
import { QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import store from 'redux/store'
import { ArticleFlat } from 'types'
import { CreateEditLinkCallbackFn, LinkDefaults } from './Types'

export const LinkPrompt = ({
  article,
  close,
  defaults,
  callback,
  initialText,
  className,
  removeLink,
}: {
  article?: ArticleFlat
  callback: CreateEditLinkCallbackFn
  close: () => void
  defaults?: LinkDefaults
  initialText: string
  className?: string
  removeLink?: () => void
}) => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Router history={getHistoryInstance()}>
          <LinkModal
            className={cx(PRIORITY_EDITOR, className)}
            initialText={defaults?.text || initialText}
            initialQuery={defaults?.query || ''}
            callback={callback}
            close={close}
            mentioningArticle={article}
            suggestRecentlyReadArticle={false}
            removeLink={removeLink}
          />
        </Router>
      </QueryClientProvider>
    </Provider>
  )
}
